export const formatPricePerSqft = ({
	price,
	area,
	string = true,
	withRupeeSymbol = true,
}: {
	price?: number;
	string?: boolean;
	area?: number;
	withRupeeSymbol?: boolean;
}): string | number => {
	if (!price || !area || area === 0 || isNaN(price) || isNaN(area)) return string ? "" : 0;
	const pricePerSqft = Math.round(price / area);
	if (!string) return pricePerSqft;
	if (!withRupeeSymbol) {
		return pricePerSqft.toLocaleString("en-IN");
	}
	return "₹" + pricePerSqft.toLocaleString("en-IN");
};
